import { defineComponent } from "vue";
import ScrollAnimation from "@i22/scroll-animation";
import ProductOfferTileMixin from "./component-library211.mjs";
import Heading from "./component-library6.mjs";
import Paragraph from "./component-library5.mjs";
import LinkButton from "./component-library3.mjs";
import ProductOfferColorSelect from "./component-library37.mjs";
import Badge from "./component-library31.mjs";
import Prices from "./component-library30.mjs";
import { useMappedPropsOptions } from "./component-library130.mjs";
const _sfc_main = defineComponent({
  name: "ProductOfferTileExtraLarge",
  components: {
    Prices,
    Badge,
    Heading,
    Paragraph,
    ProductOfferColorSelect,
    LinkButton
  },
  mixins: [
    ProductOfferTileMixin,
    ScrollAnimation,
    useMappedPropsOptions(Heading, "heading", {
      tag: "h2",
      fontWeight: "ultra"
    })
  ],
  props: {
    offerAlternatives: {
      type: Object,
      required: true
    },
    offerImages: {
      type: Object,
      default: void 0
    },
    showAvailableVariant: {
      type: Boolean
    },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    highlightText: { type: String, default: "" },
    linkTag: { type: String, default: "a" },
    absoluteLink: { type: String, default: "" },
    hasBadge: { type: Boolean, default: false },
    alignment: {
      type: String,
      default: "left",
      validator(value) {
        return ["left", "right"].includes(value);
      }
    },
    ambientImage: {
      type: String,
      default: void 0
    },
    video: {
      type: String,
      default: void 0
    },
    animationContent: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "top+=15% center",
        vars: { y: 120 }
      })
    },
    animationImage: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "top-=15% center",
        vars: { y: 120 }
      })
    },
    animationProduct: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "center center",
        vars: { y: 180 }
      })
    },
    preTextWasPrice: { type: String, default: "statt" },
    noColorTitle: { type: Boolean }
  },
  computed: {
    columnImageClass() {
      return [this.hasBadge ? "product-offer-tile-xl__column-image--has-badge" : ""].join(" ");
    }
  },
  mounted() {
    setTimeout(this.createScrollAnimations, 1);
  },
  methods: {
    createScrollAnimations() {
      if (this.animationContent) {
        this.createScrollTrigger({
          trigger: this.$refs.contentRef,
          start: this.animationContent.start,
          end: this.animationContent.end,
          scrub: 1.25,
          // @ts-ignore
          animation: this.createTweenFrom(this.$refs.contentRef, this.animationContent.vars)
        });
      }
      if (this.animationProduct && this.$refs.productImageRef) {
        this.createScrollTrigger({
          trigger: this.$refs.productImageRef,
          start: this.animationProduct.start,
          end: this.animationProduct.end,
          scrub: 1.5,
          // @ts-ignore
          animation: this.createTweenFrom(this.$refs.productImageRef, this.animationProduct.vars)
        });
      }
      if (this.animationImage && this.$refs.imageRef) {
        this.createScrollTrigger({
          trigger: this.$refs.imageRef,
          start: this.animationImage.start,
          end: this.animationImage.end,
          scrub: 1,
          // @ts-ignore
          animation: this.createTweenFrom(this.$refs.imageRef, this.animationImage.vars)
        });
      }
    }
  }
});
export {
  _sfc_main as default
};
